import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "activity",
  "use": "activity-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"activity\">\n<path d=\"M15,22c-0.4,0-0.8-0.3-0.9-0.7L9,6.2l-2.1,6.2C6.8,12.7,6.4,13,6,13H2c-0.6,0-1-0.4-1-1s0.4-1,1-1h3.3l2.8-8.3\n\tC8.2,2.3,8.6,2,9,2s0.8,0.3,0.9,0.7L15,17.8l2.1-6.2c0.1-0.4,0.5-0.7,0.9-0.7h4c0.6,0,1,0.4,1,1s-0.4,1-1,1h-3.3l-2.8,8.3\n\tC15.8,21.7,15.4,22,15,22z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol